import React from 'react';
import { GenericPaginatedDocument } from '@/components/print/GenericPaginatedDocument';
import { buildSimplePrintDocument } from '@/print-engine/adapters/simple-document';

/** Shared simple HR transaction print (leave / OT / loan / EOSB). */
export type HrmsTxnPrintData = {
  docType: string;
  title: string;
  documentNumber?: string;
  employee_name?: string;
  employee_code?: string;
  status?: string;
  company_name?: string;
  meta?: Array<{ label: string; value: string }>;
  lines?: Array<{ description: string; value: string }>;
  totals?: Array<{ label: string; value: string }>;
  notes?: string | null;
};

export const PrintableHrmsTransaction: React.FC<{
  data: HrmsTxnPrintData;
  companyName?: string;
  onClose?: () => void;
}> = ({ data, companyName, onClose }) => {
  const model = buildSimplePrintDocument({
    docType: data.docType,
    title: data.title,
    subtitle: data.status || undefined,
    documentNumber: data.documentNumber || '—',
    partyName: data.employee_name || 'Employee',
    templateId: 'a4-portrait',
    letterhead: false,
    metaLines: [
      { label: 'Company', value: companyName || data.company_name || '—' },
      { label: 'Employee', value: data.employee_name || '—' },
      { label: 'Code', value: data.employee_code || '—' },
      { label: 'Document', value: data.documentNumber || '—' },
      { label: 'Status', value: data.status || '—' },
      ...(data.meta || []),
    ],
    columns: [
      { key: 'sno', label: '#', width: '40px' },
      { key: 'desc', label: 'Particulars', width: '55%' },
      { key: 'amt', label: 'Value', width: '25%', align: 'right' },
    ],
    lines: (data.lines || []).map((l, i) => ({
      lineNumber: i + 1,
      description: l.description,
      cells: { amt: l.value },
    })),
    finals: [{ id: 'totals', heightPx: 48, keepTogetherWithNext: true }],
    renderPayload: {
      totals: data.totals || [],
      notes: data.notes || undefined,
    },
  });

  return <GenericPaginatedDocument model={model} onClose={onClose} />;
};

export default PrintableHrmsTransaction;
